import React from "react";
import { FaShieldAlt, FaAws, FaNetworkWired } from "react-icons/fa";

const certifications = [
  {
    title: "Networking Essentials",
    issuer: "Huawei Academy",
    icon: <FaNetworkWired />
  },
  {
    title: "Introduction to Cybersecurity",
    issuer: "Cisco Networking Academy",
    icon: <FaShieldAlt />
  },
  {
    title: "AWS Certified Cloud Practitioner",
    issuer: "One Million Coders",
    icon: <FaAws />
  }
];

function Certifications() {
  return (
    <section id="certifications" className="certifications">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Certifications & Training</h2>
          <p className="section-subtitle">
            Industry credentials validating core competencies in networking, cloud services, and security principles.
          </p>
        </div>

        <div className="cert-grid">
          {certifications.map((cert, i) => (
            <div key={i} className="cert-card">
              <div className="cert-icon">{cert.icon}</div>
              <div className="cert-info">
                <h3>{cert.title}</h3>
                <p className="cert-issuer">{cert.issuer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Certifications;
